import React from 'react'
import Splash from '../Splash'
import Spinner from '../Spinner'
import { status as statuses } from '@bt-react/constants'
import Icon, { IconType } from '@bt-react/components/Icon'
import Button from '@bt-react/components/Button'
import styles from './EndSplash.module.scss'
import { EndSplashProps } from './types'

const EndSplash: React.FC<EndSplashProps> = props => {

  const talkCancelled = () =>
    <div data-bdd="talk-cancelled-splash" className={styles[`splash__talk-cancelled`]}>
      <Icon
        name={IconType.iconName.danger}
        colour={IconType.colour.task}
        className={styles['icon']}
      />
      <div data-bdd="talk-cancelled-header" className={styles[`splash__talk-cancelled__header`]}>This talk has been cancelled</div>
      <p data-bdd="talk-cancelled-msg">If you require more details please contact the organiser</p>
      <Button
        text='Close'
        color={IconType.colour.primary}
        onClick={() => window.close()}
        dataBdd='end-splash-button'
      />
    </div>

  const getContent = () => {

    const { status } = props
    const { CANCELLED } = statuses

    /** Need to decide how this works as status won't be ENDING_LIVE but now will have boolean */
    if (props.isEndRequested) return <Spinner header={`Ending live talk`} />

    // Need to first consider status ===cancelled condition , otherwise it will always return the statement inside props.hasGigEnded condition
    if (status === CANCELLED) {

      return talkCancelled()

    }
    else if(props.hasGigEnded) {

      return <Spinner
        header={`This live talk has now ended`}
        body={`An on-demand version of this talk will be available soon.`}
        isComplete={true}
      />

    }
    
    return ''

  }

  return <Splash>{ getContent() }</Splash>

}

export default EndSplash
